import { Repository } from '../../../core/context/repository';
import { type ThreatVectorMitigation } from './entity';

export class ThreatVectorMitigations extends Repository<ThreatVectorMitigation> {
    getByThreatVectorId(threatVectorId: string): ThreatVectorMitigation[] {
        return this.items.filter(
            (entity) => entity.threatVectorId === threatVectorId,
        );
    }
}
